import styled from "styled-components";
import { breakpoints } from "../../globalStyles";
import { Link } from "react-router-dom";

export const BlackPageForSideMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${({ zIndex }) => zIndex - 1};

  /* Пусть пока останется, вдруг попросят вернуть */
  /* background-color: rgba(37, 37, 37, 0.8); */
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 6px 0;
  max-width: 1520px;
  margin: 0 auto;

  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;

  color: #fff;
  font-size: 20px;

  @media ${breakpoints.md} {
    padding-top: 1em;
    font-size: 16px;
  }

  @media (max-width: 320px) {
    padding: 6px 8px;
  }
`;

export const MenuLink = styled(Link)`
  font-weight: 500;
  font-size: 16px;
  line-height: 22.4px;
  text-transform: uppercase;
  padding: 0;
  &:hover {
    color: #ed6c45;
  }
  ${({ active }) =>
    active &&
    `
    color: #ed6c45;
  `}
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

export const AuthBtn = styled.button`
  font-weight: 500;
  font-size: 16px;
  line-height: 22.4px;
  text-align: center;
  text-transform: uppercase;
  transition: color 50ms ease-out;
  padding: 0;
  &:hover {
    color: #ed6c45;
  }
  &:active {
    color: #d4603d;
  }
  &:disabled {
    opacity: 0.3;
  }
  @media ${breakpoints.sm} {
    font-size: 16px;
  }
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

export const ModalClose = styled.div`
  position: absolute;
  top: 5%;
  right: 4%;
  z-index: 99;
  background: transparent;
  font-weight: 400;
  font-size: 20px;
  line-height: 25px;
  text-transform: uppercase;
  cursor: pointer;
  transition: color 50ms ease-out;

  &:hover {
    color: #ed6c45;
  }
  & svg {
    margin-left: 20px;
  }
  & svg > path {
    transition: all 50ms ease-out;
  }
  &:hover svg > path {
    fill: #ed6c45;
  }
`;

export const HeaderLogoImg = styled.img`
  display: block;

  @media ${breakpoints.sm} {
    width: 110px;
    height: 20px;
  }
`;

export const MenuWrapper = styled.div`
  display: flex;
  gap: 24px;

  @media ${breakpoints.md} {
    visibility: hidden;
    opacity: 0;
    transition: all 0.1s linear;
    padding-top: 72px;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.94);
    z-index: 99;

    ${({ showMenu }) =>
      showMenu &&
      `
     visibility: visible;
     opacity: 1;
     transition: opacity 0.1s linear;
  `}
  }
`;

export const CloseMenuButton = styled.button`
  position: absolute;
  right: 20px;
  top: 16px;

  @media ${breakpoints.xs} {
    right: 16px;
  }
`;

export const OpenMenuButton = styled.button`
  display: none;

  @media ${breakpoints.md} {
    display: block;
  }
`;
